import SumsubWebSdk from '@sumsub/websdk-react';
import type { VerificationServiceWidgetConfiguration } from '../api/types';

type Props = {
  widgetConfiguration: VerificationServiceWidgetConfiguration;
  getNewAccessToken: () => Promise<string>;
};

const SumsubWidget = ({ widgetConfiguration, getNewAccessToken }: Props) => {
  return (
    <SumsubWebSdk
      accessToken={widgetConfiguration.accessToken}
      expirationHandler={getNewAccessToken}
      onError={error => {
        console.error('Sumsub widget error:', error);
      }}
    />
  );
};

export { SumsubWidget };
